import Vue from 'vue'

const requireComponents = require.context('./component', true, /\.vue$/);

requireComponents.keys().forEach(file => {

    const componentConfig = requireComponents(file)

    const componentName = componentConfig.default.name

    // Vue.component 组件名, 组件配置
    Vue.component(componentName, componentConfig.default || componentConfig)
});